const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const DIGITS = /^\d+$/;

/** Funnel-relevant pages, named for Product Analytics. Everything else gets the derived name. */
const aliases: Record<string, string> = {
  "/customer/:customerId": "cfc/home",
  "/customer/:customerId/ccf": "cfc/ccf-overview",
  "/customer/:customerId/ccf/:id": "cfc/ccf-calculation",
};

const normaliseSegment = (segment: string, index: number, segments: string[]): string => {
  if (index > 0 && segments[index - 1] === "customer") {
    return ":customerId";
  }
  // Every id in a cfc-frontend URL is a UUID today. DIGITS is insurance against a future route
  // with a numeric id reintroducing per-record cardinality.
  if (UUID.test(segment) || DIGITS.test(segment)) {
    return ":id";
  }
  return segment;
};

/**
 * Turns a pathname into a stable, low-cardinality RUM view name. The raw URL carries the customer
 * slug and ids, so Product Analytics cannot group pages by it. A derivation rather than a route
 * table, so a new route is named correctly without anyone remembering to add it.
 */
export const toRumViewName = (pathname: string): string => {
  const segments = pathname.split("/").filter(Boolean);
  const normalised = segments.map(normaliseSegment);
  const path = `/${normalised.join("/")}`;

  return aliases[path] ?? (normalised.length === 0 ? "cfc/root" : `cfc${path}`);
};
